<script>
  /**
   * HTML 標準機能を利用した数値入力欄
   *  - min, max, step 設定可能
   */
  import TextInput from './TextInput.svelte'

  export let id = undefined
  export let name
  export let label = ''
  export let value = undefined

  export let min = null
  export let max = null
  export let step = null
</script>

<TextInput
  id={`${id || name}NumberInput`}
  {name}
  type="number"
  {label}
  inputAttributes={{ inputmode: 'decimal', min, max, step }}
  bind:value
/>
